import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { getCameraStreamAction } from "./actions/cameraActions";

interface CameraState {
  loader: true | false;
  cameraLink: {};
}
const initialState: CameraState = {
  loader: false,
  cameraLink: {},
};

export const cameraSlice = createSlice({
  name: "camera",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get getPaymentTypes methods
    builder.addCase(getCameraStreamAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getCameraStreamAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getCameraStreamAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.cameraLink = payload;
    });
  },
});

export const loader = (state: RootState) => state.camera.loader;
export const cameraURL = (state: RootState) => state.camera.cameraLink;
